module.exports = __webpack_public_path__ + "static/media/helen.1d77af03.jpg";